/* eslint-disable @altermaind/you-shall-not-pass */
import { EMAIL_SUPPORT } from '@/_shared/constants/general';
import {
  SubscriptionIntervalType,
  SubscriptionPaymentMethod,
  SubscriptionPlanType,
} from '@/billing/state';
import { ClusterType } from '@/swagger/constants/credits-enums';

export const it = {
  settings: {
    pageTitle: 'Impostazioni',
    tabs: {
      plan: {
        title: 'Piano',
        companyName: 'Nome azienda',
        companyVatNumber: 'Partita IVA',
        companyAlert: 'Vuoi modificare i dati aziendali?',
        companyAlertLink: 'Contattaci',
        companyAlertSuffix: 'per aggiornare le informazioni della tua azienda.',
        noActivePlan: {
          title: 'Nessun piano attivo',
          description:
            'Si è verificato un problema durante l’attivazione del tuo piano. Stiamo lavorando per risolverlo.\nPer assistenza o informazioni, scrivici a slash@altermaind.com',
        },
        yourPlan: {
          title: 'Il Tuo Piano',
          statusActive: 'Subscription attiva',
          statusTrial: {
            one: 'Prova {{count}} giorno attiva',
            other: 'Prova {{count}} giorni attiva',
          },
          learningLicenses: 'Licenze Learning',
          learningLicensesTooltip:
            'Una licenza learning abilita l’accesso alla piattaforma a tutti i dipendenti a cui saranno somministrati gli assessment. Viene attivata quando il destinatario della licenza riceve il primo assessment. Puoi gestire le licenze attive dalla sezione Anagrafiche.',
          adminLicenses: 'Licenze Admin',
          adminLicensesTooltip:
            'La licenza admin corrisponde a un’utenza admin o delegato che non è operativa sulla learning dashboard. Questo tipo di licenza non contribuisce alla fatturazione di Slash.',
          trialMonthlyPrice: '{{price}}',
          monthlyPricePerLicensePrice: '{{price}}/',
          monthlyPricePerLicenseSuffix: ' mese per licenza learning',
          trialPriceSubtitle: {
            days: {
              one: 'Gratis il primo giorno, poi {{price}}/ mese per licenza learning.',
              other: 'Gratis i primi {{count}} giorni, poi {{price}}/ mese per licenza learning.',
            },
            months: {
              one: 'Gratis il primo mese, poi {{price}}/ mese per licenza learning.',
              other: 'Gratis i primi {{count}} mesi, poi {{price}}/ mese per licenza learning.',
            },
          },
          pricesVatExcluded: 'Il prezzo è da intendersi IVA esclusa',
          offlineReviewOffer: 'Se vuoi rivedere l’offerta',
          offlineReviewOfferCta: 'Prenota una consulenza',
          offlineContractDetails:
            'Ulteriori dettagli sul pagamento e i servizi inclusi sono riportati nel contratto.',
          learningLimitExceededAlert:
            'Hai oltre {{max}} licenze learning attive. Valuta il passaggio a un’offerta Custom per ridurre i costi.',
          learningLimitExceededCta: 'Fissa una consulenza',
        },
        planTitles: {
          STANDARD: 'Il Tuo Piano',
          CUSTOM: 'Il Tuo Piano',
          CUSTOM_OFFLINE: 'Il Tuo Piano',
        } satisfies Record<SubscriptionPlanType, string>,
        billingInterval: {
          DAY: { one: 'Ogni giorno', other: 'Ogni {{count}} giorni' },
          WEEK: { one: 'Ogni settimana', other: 'Ogni {{count}} settimane' },
          MONTH: { one: 'Ogni mese', other: 'Ogni {{count}} mesi' },
          YEAR: { one: 'Ogni anno', other: 'Ogni {{count}} anni' },
        } satisfies Record<SubscriptionIntervalType, { one: string; other: string }>,
        paymentMethods: {
          CARD: 'Carta',
          SEPA_DEBIT: 'Addebito SEPA',
        } satisfies Record<SubscriptionPaymentMethod, string>,
        details: {
          title: 'Dettagli piano',
          activationDate: 'Data di attivazione:',
          billingType: 'Tipo di fatturazione:',
          paymentMethod: 'Metodo di pagamento:',
          nextInvoice: 'Prossima rata:',
          managePlanCta: 'Gestisci piano e pagamenti',
          customNeeds:
            'Hai esigenze specifiche di volume, configurazione o servizi che superano il tuo piano?',
          customNeedsCta: 'Prenota una consulenza',
          customNeedsSuffix: 'per avere un piano personalizzato',
        },
        included: {
          title: 'INCLUSO NEL PIANO:',
          measurement: {
            title: 'MISURAZIONE',
            measurementSoftSkills: 'Assessment soft skills ogni 12 mesi',
            measurementHardSkills: 'Assessment hard skills ogni 6 mesi',
            measurementOnDemand: 'Assessment ad hoc su richiesta',
          },
          coaching: {
            title: 'COACHING SUI RISULTATI',
            coachingHr: '1 consulenza per il team HR ogni 12 mesi',
            coachingOneToOne:
              'Fino a 20 consulenze one to one per i tuoi dipendenti con il team di Slash',
          },
          training: {
            title: 'TRAINING',
            trainingCatalog: 'Catalogo corsi free in continuo aggiornamento (video, quiz e guide)',
            trainingCustom: 'Training personalizzato sulla base dei pain point',
          },
          aiBoost: {
            title: 'AI-BOOST',
            aiBoostFeatures: 'AI assistant sulle funzionalità e il modello',
          },
        },
      },
      delegates: {
        title: 'Admin e Delegati',
        admin: {
          title: 'Admin HR',
          firstName: 'Nome Admin',
          email: 'Email Admin',
        },
        filter: 'Filtri',
        search: {
          placeholder: 'Cerca',
        },
        listTitle: 'Elenco Delegati',
        searchDelegates: 'Cerca delegato',
        resendInvite: {
          dialog: {
            title: 'Ripeti invio delega',
            description: 'Stai per inviare nuovamente l’invito a {{fullName}}.',
            confirmation: 'Sei sicuro di voler procedere?',
            buttons: {
              confirm: 'Invia di nuovo',
              cancel: 'Annulla',
            },
            success: 'Invito inoltrato con successo',
          },
        },
        filterDelegates: {
          status: {
            label: 'Stato',
          },
          buttons: {
            save: 'Salva',
            cancel: 'Reset',
          },
        },
        removeDelegate: {
          dialog: {
            title: 'Rimuovi Delegato',
            description:
              'Stai rimuovendo un delegato. Una volta rimosso, il delegato non potrà più accedere alla Admin dashboard.',
            confirmation: 'Sei sicuro di proseguire?',
            buttons: {
              confirm: 'Rimuovi',
              cancel: 'Annulla',
            },
          },
        },
        addDelegate: {
          emptyState: {
            title: 'Elenco delegati',
            description:
              "Non sono ancora presenti Delegati relativi all'Organizzazione. Clicca su “Aggiungi Delegato” qui sotto, per inserire il primo.",
            alert:
              "I Delegati dell'Organizzazione hanno gli stessi poteri dell’Admin, eccetto invitare altri Delegati all'interno dell’Organizzazione. Per maggiori informazioni, consulta la !{DOCS}! o !{CONTACT}!",
            labelDocs: 'guida',
            labelContact: 'contattaci',
            button: 'Aggiungi Delegato',
          },
          dialog: {
            title: 'Aggiungi Delegato',
            chooseTeamsOrGuest: {
              description:
                'Un delegato può aiutarti a gestire anagrafiche, assessment, analisi e reportistiche. Ti suggeriamo di scegliere i Delegati nel dipartimento solitamente dedicato alla gestione delle persone, ma puoi selezionare chiunque tu ritenga adatto.',
              listOfTeamsLabel: 'Team:',
              addDelegateGuestQuestion:
                'Vuoi delegare un nuovo utente non ancora registrato su Slash?',
              addDelegateGuestCta: 'Aggiungi',
              noDepartmentsFound: 'Non sono stati trovati dipartimenti',
              unknownDepartment: 'Non assegnato',
            },
            delegateEmployees: {
              description:
                'Ecco le persone che possono supportarti nella gestione quotidiana delle attività.',
              noResults: 'Nessun profilo trovato in questo dipartimento',
              table: {
                people: 'persone',
                name: 'Nome',
                role: 'Ruolo',
                email: 'Email',
              },
              cta: {
                goBack: 'Indietro',
                next: 'Avanti',
              },
              confirm: {
                title: 'Conferma Delegati',
                description: 'Ecco il riepilogo dei delegati',
                department: 'Dipartimento',
                role: 'Ruolo',
                email: 'Email',
                cta: {
                  confirm: 'Aggiungi',
                  changeSelection: 'Modifica selezione',
                },
                infoBadge: 'Il delegato riceverà una email di notifica per l’accesso',
              },
            },
            fields: {
              firstName: 'Nome Delegato',
              lastName: 'Cognome Delegato',
              email: 'Email Delegato',
              selectedEmployee: 'Cerca per nome e cognome',
            },
            alertInvalidEmail: "Il formato dell'email non è valido. Controlla e riprova",
            step0: {
              descriptionLine1:
                'Un delegato può aiutarti a gestire anagrafiche, questionari, analisi e reportistica.',
              descriptionLine2:
                ' Ti suggerisco di scegliere dal team HR, ma puoi selezionare chiunque tu ritenga adatto.',
              titleCard: 'Scegli da tutti i dipendenti',
              peopleLabel: 'persone',
              descriptionNoPeople: 'Vuoi delegare un nuovo utente non ancora registrato su Slash?',
            },
            step2: {
              fields: {
                firstName: 'Nome',
                role: 'Ruolo',
                email: 'Email',
              },
              recap: 'Riepilogo: {{count}} persona verrà aggiunta come delegato',
              description:
                "Seleziona la persona che vuoi nominare come delegato tra tutte le persone dell'azienda",
              alert:
                'Stai scegliendo al di fuori del dipartimento HR. Assicurati che la persona selezionata abbia familiarità con i processi HR e le policy aziendali.',
              all: 'Tutti i dipendenti',
            },
            buttons: {
              next: 'Avanti',
              save: 'Aggiungi',
              close: 'Annulla',
              back: 'Indietro',
              addNewUser: 'Aggiungi un delegato',
            },
          },
        },
        table: {
          firstName: 'Nome Delegato',
          lastName: 'Cognome Delegato',
          email: 'Email Delegato',
          status: {
            label: 'Stato delega',
          },
          tooltips: {
            remove: 'Rimuovi delegato',
            resendInvite: 'Reinvia invito',
          },
        },
      },
      credits: {
        title: 'Crediti',
        noData: {
          title: 'Crediti',
          description:
            'Non ci sono ancora dati disponibili: invia l’assessment per iniziare a monitorare il consumo dei crediti.',
        },
        recap: {
          title: 'Analisi crediti',
          nextRecharge: 'Rinnovo crediti: !{DATE}! ({{days}} giorni rimanenti)',
          description:
            'I dati considerano solo i profili invitati a registrarsi su Slash (inclusi gli utenti attivi). Sono esclusi i profili caricati ma mai invitati.',
        },
        progress: {
          total: 'Crediti spesi nel periodo selezionato: ',
          overall: 'Utilizzo dei crediti',
          overallTooltip:
            "La percentuale indica la quota di crediti utilizzati rispetto all’assegnazione complessiva disponibile per l'organizzazione. Poiché i crediti si accumulano per tre mesi, l’utilizzo reale mensile può superare il 100%, anche se i valori visualizzati non andranno mai oltre tale soglia.",
          media: 'Media mensile di utilizzo: ',
        },
        cluster: {
          labelPerson: 'persone in {{clusterName}}',
          title: 'Dettaglio di utilizzo crediti',
          description:
            'Ogni fascia mostra il livello medio di utilizzo dei crediti da parte degli utenti dell’organizzazione. La distribuzione aiuta a capire chi sfrutta pienamente i crediti disponibili e chi invece ha margine di coinvolgimento.',
          table: {
            cluster: 'Cluster',
            clusterTooltip:
              'I cluster sono calcolati sul consumo dei crediti complessivi nel periodo selezionato',
            media: 'Media crediti',
            mediaLabel: 'crediti/mese',
            person: 'Persone',
            personLabel: 'persone',
          },
          [ClusterType.INATTIVI]: {
            label: 'Inattivi',
            subLabel: '0%',
          },
          [ClusterType.SOTTO_UTILIZZATORI]: {
            label: 'Sotto-utilizzatori',
            subLabel: '1-29%',
          },
          [ClusterType.OCCASIONALI]: {
            label: 'Occasionali',
            subLabel: '30-49%',
          },
          [ClusterType.MODERATI]: {
            label: 'Moderati',
            subLabel: '50-69%',
          },
          [ClusterType.REGOLARI]: {
            label: 'Regolari',
            subLabel: '70-89%',
          },
          [ClusterType.INTENSIVI]: {
            label: 'Intensivi',
            subLabel: '90-100%',
          },
        },
        department: {
          title: 'Utilizzo dei crediti per dipartimento',
          showMore: 'Scopri di più',
          showLess: 'Mostra meno',
          alertLabel:
            'Vuoi avere delle analisi più approfondita? !{LINK}!, ed esplora il dipartimento di interesse',
          alertLinkLabel: 'vai su Dipartimenti',
          description:
            'Dettaglio dell’utilizzo dei crediti per ciascun dipartimento aziendale, con indicazione dei consumi medi per persona e della quota utilizzata rispetto all’assegnazione del periodo selezionato.',
          buttonCta: 'Visualizza crediti',
          creditPerPerson: 'Consumo medio per persona: !{TOTAL}! crediti',
        },
        trend: {
          title: 'Consumo medio e trend',
          description:
            'Media e andamento dei consumi, a livello aziendale, nel periodo selezionato.',
          chartTitle: 'Trend utilizzo crediti',
          averageMonthlyUsage: 'Media mensile di utilizzo',
          averageMonthlyUsageTooltip:
            'Indica il numero medio di crediti spesi da ciascun dipendente nel periodo selezionato. Nei periodi plurimensili il valore è già normalizzato su base mensile, così da poterlo confrontare con i singoli mesi.',
          creditLabel: 'crediti per persona',
          creditsLabel: 'crediti',
          trendLabel: 'Trend trimestre',
          trendLabelTooltip:
            'Mostra la variazione percentuale (e in crediti) dell’utilizzo medio per persona rispetto al periodo precedente dello stesso tipo (mese o trimestre). Serve a individuare trend di crescita o di calo.',
        },
      },
      aspect: {
        tabTitle: 'Identità visiva',
        title: "Configura l'aspetto della tua piattaforma Slash",
        description:
          "Personalizza l'aspetto della piattaforma per la tua organizzazione con il tuo brand. Inserisci l'indirizzo del suo sito e lascia fare l'AI o carica i loghi e scegli il colore che preferisci",
        siteLabel: 'Sito web della tua azienda',
        sitePlaceholder: 'https://',
        siteDescription:
          '{{remainingDesignQuota}}/{{totalDesignQuota}} prove disponibili per caricare il logo partendo dalla pagina web inserita',
        alert:
          "Per un'esperienza ottimale, ti consigliamo di caricare il logo in entrambe le versioni: chiara (light) e scura (dark). Se ne hai caricato solo una, la versione mancante verrà generata dall'AI",
        remainingDesignQuotaZeroAlert:
          'Non hai più tentativi disponibili per visualizzare l’anteprima. Puoi provare a caricare i loghi manualmente.',
        alertError:
          'Non è stato possibile recuperare i loghi dall’URL inserita. Prova con un link diverso oppure caricali manualmente.',
        alertErrorColors:
          'Non è stato possibile recuperare i colori del tema. Prova con un link diverso oppure selezionalo manualmente.',
        cta: {
          generate: 'Genera',
          save: 'Salva',
        },
        loading: {
          title: 'L’AI sta analizzando la pagina inserita',
          description: 'I loghi verranno presto visualizzati in anteprima in pagina',
        },
        errors: {
          designQuotaExceeded:
            'Hai superato il numero di prove disponibili per caricare il logo partendo dalla pagina web. Puoi caricarlo manualmente oppure contattare il supporto per aumentare il tuo piano.',
        },
        uploadLogo: {
          titleWhiteMode: 'Logo aziendale White mode',
          titleTooltipWhiteMode: 'Versione scura del logo, ideale per sfondi chiari.',
          titleDarkMode: 'Logo aziendale Dark mode',
          titleTooltipDarkMode: 'Versione chiara del logo, ideale per sfondi scuri o colorati.',
        },
        titleColor: 'Colore tema',
        previewLabel: 'Anteprima piattaforma',
        previewLabelTooltip:
          'Qui puoi vedere un’anteprima della piattaforma in modalità dark e light. La scelta del tema è personale e può essere gestita da ciascun utente direttamente in piattaforma dal dropdown in alto a destra.',
      },
    },
    tutorial: {
      title: 'Gestisci le tue impostazioni',
      slides: {
        slide1: {
          title: 'Consulta le informazioni sul tuo piano',
          description:
            'Tieni sotto controllo le licenze utilizzate, monitora i costi mensili per licenza se applicabile al tuo piano, gestisci il metodo di pagamento e visualizza lo storico delle fatture.',
        },
        slide2: {
          title: 'Visualizza i dati della tua azienda',
          description: `In questa sezione puoi visualizzare le informazioni principali della tua azienda, come il nome e la partita IVA. Questi dati non sono modificabili direttamente: se hai bisogno di aggiornamenti contattaci a ${EMAIL_SUPPORT}`,
        },
        slide3: {
          title: 'Amministra Admin e Delegati',
          description:
            'Puoi visualizzare i dati dell’Admin principale e aggiungere o gestire i Delegati. I Delegati hanno gli stessi poteri dell’Amministratore, con un’unica eccezione: non possono invitare altri Delegati. In questo modo un Admin può condividere la gestione della piattaforma senza perderne il pieno controllo.',
        },
        slide4: {
          title: 'Monitora i consumi dei crediti',
          description:
            'Accedi alla dashboard per visualizzare l’analisi completa del consumo dei crediti. Tieni monitorato l’utilizzo aziendale e per dipartimento nel tempo.',
        },
        slide5: {
          title: 'Personalizza Slash per la tua azienda',
          description:
            "Carica il logo della tua azienda oppure inserisci il link al sito per farlo rilevare all'AI in automatico. Scegli il colore per la piattaforma che preferisci e visualizza l’anteprima di come apparirà Slash, sia in dark che white mode.",
        },
      },
    },
  },
};
